const Constants = {
  debug: false,
};

export default Constants;
